<template>
    <div class="b-table-sticky-header table-responsive">
        <b-table-simple
            no-border-collapse
        >
            <b-thead>
                <b-tr class="text-center">
                    <b-th
                        class="text-nowrap text-left"
                    >
                        Date
                    </b-th>
                    <b-th
                        class="text-nowrap text-right"
                    >
                        Transfer-Out
                    </b-th>
                    <b-th
                        class="text-nowrap text-right"
                    >
                        Transfer-In
                    </b-th>
                    <b-th
                        style="width:30%;"
                        class="text-nowrap text-right"
                    >
                        Etc.
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="data.length">
                <b-tr>
                    <b-td rowspan="2" style="text-align:left;" class="text-nowrap">
                        <strong>
                            {{ totalMonth }} Total
                        </strong>
                    </b-td>
                    <b-td style="text-align:right" class="text-nowrap">
                        <strong>
                            {{ $_getAmount(sum.Out.usageAmount, 'DataTransfer') }}
                        </strong>
                    </b-td>
                    <b-td style="text-align:right" class="text-nowrap">
                        <strong>
                            {{ $_getAmount(sum.In.usageAmount, 'DataTransfer') }}
                        </strong>
                    </b-td>
                    <b-td style="text-align:right" class="text-nowrap">
                        <strong>
                            {{ $_getAmount(sum.Etc.usageAmount, 'DataTransfer') }}
                        </strong>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td style="text-align:right">
                        <strong>
                            {{ $_getDollar(sum.Out.cost, 'DataTransfer') }}
                        </strong>
                    </b-td>
                    <b-td style="text-align:right">
                        <strong>
                            {{ $_getDollar(sum.In.cost, 'DataTransfer') }}
                        </strong>
                    </b-td>
                    <b-td style="text-align:right">
                        <strong>
                            {{ $_getDollar(sum.Etc.cost, 'DataTransfer') }}
                        </strong>
                    </b-td>
                </b-tr>
                <template v-for="({ date, Out, In, Etc }, index) in tableData">
                    <b-tr :key="`amount-${index}`">
                        <b-td rowspan="2" style="text-align:left">
                            {{ date.substring(2, 10) }}
                        </b-td>
                        <b-td style="text-align:right">
                            {{ $_getAmount(Out.usageAmount, 'DataTransfer') }}
                        </b-td>
                        <b-td style="text-align:right">
                            {{ $_getAmount(In.usageAmount, 'DataTransfer') }}
                        </b-td>

                        <b-td style="text-align:right">
                            {{ $_getAmount(Etc.usageAmount, 'DataTransfer') }}
                        </b-td>
                    </b-tr>
                    <b-tr :key="`dollar-${index}`">
                        <b-td style="text-align:right">
                            {{ $_getDollar(Out.cost) }}
                        </b-td>
                        <b-td style="text-align:right">
                            {{ $_getDollar(In.cost) }}
                        </b-td>
                        <b-td style="text-align:right">
                            {{ $_getDollar(Etc.cost) }}
                        </b-td>
                    </b-tr>
                </template>
            </b-tbody>
            <b-tbody v-else>
                <b-tr>
                    <b-td colspan="4" class="pb-50 pt-2 text-center">
                        <SVGEmptyIcon/>
                        <div>

                            {{ $t("org.message.No Data") }}
                        </div>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { toRefs, computed } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const { data } = toRefs(props)
        const tableData = computed(() => {
            return data.value.map(({ date, types }) => {
                const typeValue = types.reduce((accumulator, currentValue) => {
                    accumulator[currentValue.type].cost = currentValue.cost
                    accumulator[currentValue.type].usageAmount = currentValue.usageAmount
                    return accumulator
                }, {
                    In: {
                        cost: 0,
                        usageAmount: 0
                    },
                    Out: {
                        cost: 0,
                        usageAmount: 0
                    },
                    Etc: {
                        cost: 0,
                        usageAmount: 0
                    }
                })
                return {
                    date,
                    ...typeValue
                }
            })
        })
        const totalMonth = computed(() => tableData.value.length > 0 ? tableData.value[0].date.substring(2, 7) : '')
        const sum = computed(() => {
            return tableData.value.reduce((accumulator, currentValue) => {
                accumulator.In.cost += (currentValue.In && currentValue.In.cost) || 0
                accumulator.In.usageAmount += (currentValue.In && currentValue.In.usageAmount) || 0
                accumulator.Out.cost += (currentValue.Out && currentValue.Out.cost) || 0
                accumulator.Out.usageAmount += (currentValue.Out && currentValue.Out.usageAmount) || 0
                accumulator.Etc.cost += (currentValue.Etc && currentValue.Etc.cost) || 0
                accumulator.Etc.usageAmount += (currentValue.Etc && currentValue.Etc.usageAmount) || 0
                return accumulator
            }, {
                In: {
                    cost: 0,
                    usageAmount: 0
                },
                Out: {
                    cost: 0,
                    usageAmount: 0
                },
                Etc: {
                    cost: 0,
                    usageAmount: 0
                }
            })
        })
        return {
            tableData,
            totalMonth,
            sum
        }
    }
}
</script>

<style>

</style>
